import { BadgeCheck } from 'lucide-react';

/** Indigo bricka "Original" för originaldelar (se lib/kvalitet.ts). */
export function OriginalBadge({ storlek = 'liten' }: { storlek?: 'liten' | 'stor' }) {
  const stor = storlek === 'stor';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-brand text-white font-semibold ${
        stor ? 'px-2.5 py-1 text-xs' : 'px-1.5 py-0.5 text-[10px] sm:text-[11px]'
      }`}
      title="Originaldel från biltillverkaren"
    >
      <BadgeCheck className={stor ? 'h-3.5 w-3.5' : 'h-3 w-3'} aria-hidden />
      Original
    </span>
  );
}
